import React, { useEffect, useState } from 'react';
import { isLocalEnvironment } from '../../utils/environmentDetection';
import { isFeatureEnabled } from '../../services/featureEnabledService';
import AgentChatPanel from './AgentChatPanel';

const AGENT_CHAT_FEATURE_NAME = 'RCC_AGENT_CHAT';

/**
 * Gated wrapper for AgentChatPanel.
 *
 * - Local dev: always allowed (no Boson frame to resolve alias).
 * - All other environments: calls IsFeatureEnabled API on the facade service.
 *   Backend returns true for everyone in beta/gamma, and checks allowlist in prod.
 * - Fail-closed: if the API call fails, the panel is hidden.
 */
const AgentChatPanelGated: React.FC = () => {
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    // Local dev: always allow — getUserName() can't resolve without Boson frame
    if (isLocalEnvironment()) {
      setAllowed(true);
      return;
    }

    // All deployed environments: let backend decide
    isFeatureEnabled(AGENT_CHAT_FEATURE_NAME)
      .then(setAllowed)
      .catch(() => setAllowed(false));
  }, []);

  if (!allowed) return null;
  return <AgentChatPanel />;
};

export default AgentChatPanelGated;
